(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .constant('favoritesResolver', {
            players: getPlayers,
        });

    getPlayers.$inject = ['Member', 'user'];
    function getPlayers(Member, user) {
        return Member.getFriends({ id: user.id }, true).$promise;
    }
})();